import { Box, IconButton } from "@material-ui/core";
import { ClearOutlined, Check, Close } from "@material-ui/icons";
import CheckboxWithoutLabel from "Components/formControls/HookFields/CheckboxWithoutLabel";
import InputField from "Components/formControls/HookFields/InputFieldWithText";
import { get } from "lodash";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOrganizationValidation } from "Validations/Organization/useOrganizationValidation";
import useStyles from "../../styles";

const EditQuestions = ({ question, name, index, remove = true }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    register,
    setValue,
    watch,
    control,
    formState: { errors }
  } = useFormContext();
  const allQuestions = watch(name);
  const { disabledView } = watch();
  const singleQuestion = { ...question };
  const { organizationDefaultQuestionError } = useOrganizationValidation();

  const onChecked = () => {
    setValue(`${name}.${index}.isSelected`, !singleQuestion?.isSelected);
  };
  const removeQuestion = () => {
    setValue(
      name,
      allQuestions.filter((_, idx) => idx != index)
    );
  };
  return (
    <Box>
      {disabledView ? (
        <Box>
          <ul className={classes.qusList}>
            <li>
              <span>
                {singleQuestion?.isSelected ? (
                  <Check fontSize="small" className={classes.checkIcon} />
                ) : (
                  <Close fontSize="small" className={classes.crossIcon} />
                )}
              </span>
              <span
                className={singleQuestion?.isSelected ? "" : classes.crossIcon}>
                {singleQuestion?.question}
              </span>
            </li>
          </ul>
        </Box>
      ) : (
        <Box display={"flex"} justifyContent="space-between" mb={1}>
          <CheckboxWithoutLabel
            register={register(`${name}.${index}.isSelected`)}
            isChecked={singleQuestion?.isSelected}
            // disabled={disabledView}
            onChange={() => onChecked()}
          />
          <Controller
            register={register(
              `${name}.${index}.question`,
              organizationDefaultQuestionError
            )}
            name={`${name}.${index}.question`}
            control={control}
            render={({ field }) => {
              const { onChange } = field;
              return (
                <InputField
                  onChange={e => onChange(e.target.value.trimLeft())}
                  value={singleQuestion?.question}
                  error={get(errors, `${name}.${index}.question.message`, "")}
                  // disabled={disabledView}
                />
              );
            }}
          />

          {remove ? (
            <IconButton
              data-testid="icon"
              aria-label="delete"
              // size="small"
              // className={classes.deleteQus}
              // disabled={props.isCompanySetting ? true : false}
              // disabled={disabledView}
              onClick={removeQuestion}>
              <ClearOutlined fontSize="small" />
            </IconButton>
          ) : null}
        </Box>
      )}
    </Box>
  );
};

export default EditQuestions;
